import React, { memo } from 'react';
import Svg, { Path } from 'react-native-svg';

export const IconBasket = memo(({ color = '#FFF', size = 24, ...rest }) => {
  return (
    <Svg width={size} height={size} viewBox="0 0 24 24" {...rest}>
      <Path
        fill={color}
        d="M18 18a2 2 0 11-2 2c0-1.11.89-2 2-2M2 2h3.27l.94 2H21a1 1 0 011 1c0 .17-.05.34-.12.5l-3.58 6.47c-.34.61-1 1.03-1.75 1.03H9.1l-.9 1.63-.03.12c0 .138.112.25.25.25H20v2H8a2 2 0 01-2-2c0-.35.09-.68.24-.96l1.36-2.45L4 4H2V2m6 16a2 2 0 11-2 2c0-1.11.89-2 2-2m9-7l2.78-5H7.14l2.36 5H17z"
      />
    </Svg>
  );
});
